import { h as s } from "vue";
import { elementHasScrollX as c, elementHasScrollY as a } from "../../utils/dom.js";
/* empty css                     */
const u = {
  name: "PendoScrollIndicator",
  props: {
    disabled: {
      type: Boolean
    }
  },
  compatConfig: {
    RENDER_FUNCTION: !1
  },
  data() {
    return {
      canScroll: {
        up: !1,
        down: !1,
        left: !1,
        right: !1
      }
    };
  },
  watch: {
    async disabled() {
      await this.$nextTick(), this.setupObservers();
    }
  },
  mounted() {
    this.setupObservers();
  },
  methods: {
    setupObservers() {
      this.disabled || (this.resizeObserver || (this.resizeObserver = new ResizeObserver(this.toggleIndicators), this.$once("hook:beforeUnmount", () => this.resizeObserver.disconnect())), this.resizeObserver.observe(this.$refs.content), this.mutationObserver || (this.mutationObserver = new MutationObserver(this.toggleIndicators), this.$once("hook:beforeUnmount", () => this.mutationObserver.disconnect())), this.mutationObserver.observe(this.$refs.content, {
        childList: !0,
        attributes: !1
      }));
    },
    toggleIndicators() {
      const t = this.$refs.content;
      if (!t)
        return;
      const e = c(t), o = a(t), r = t.scrollTop === 0, i = t.scrollLeft === 0, l = t.scrollWidth - t.scrollLeft - t.offsetWidth < 1, n = t.scrollHeight - t.scrollTop - t.offsetHeight < 1;
      this.canScroll.up = o && !r, this.canScroll.down = o && !n, this.canScroll.right = e && !l, this.canScroll.left = e && !i;
    }
  },
  render() {
    if (this.disabled) {
      const e = this.$slots.default && this.$slots.default();
      return e ? e.length < 2 && !e[0].text ? e : s("div", e) : s();
    }
    const t = () => this.$slots.indicators ? this.$slots.indicators({ canScroll: this.canScroll }) : ["up", "down", "left", "right"].map((e) => s("div", {
      class: [
        "pendo-scroll-indicator__shadow",
        `pendo-scroll-indicator__shadow--${e}`,
        {
          "is-active": this.canScroll[e]
        }
      ]
    }));
    return s(
      "div",
      {
        class: "pendo-scroll-indicator"
      },
      [
        s(
          "div",
          {
            class: "pendo-scroll-indicator__content",
            ref: "content",
            onScrollPassive: this.toggleIndicators
          },
          [this.$slots.default(), t()]
        )
      ]
    );
  }
};
export {
  u as default
};
//# sourceMappingURL=pendo-scroll-indicator.js.map
